import React from 'react';
import { StyledTab, StyledTab2 } from '../../../styles/globalStyles';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  key: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export const TabPanel = ({
  tabs,
  panelData,
  styleType = 'type1'
}: {
  tabs: string[];
  panelData: React.ReactNode[];
  styleType?: string;
}) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const StyledComponent = styleType === 'type1' ? StyledTab : StyledTab2;

  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <StyledComponent
          value={value}
          onChange={handleChange}
          aria-label="Tabs example"
        >
          {tabs.map((title, index) => {
            return (
              <Tab
                label={title}
                key={index}
                tabIndex={0}
                {...a11yProps(index)}
              />
            );
          })}
        </StyledComponent>
      </Box>
      {panelData.map((Panel: React.ReactNode, index: number) => {
        return (
          <CustomTabPanel value={value} index={index} key={index}>
            {Panel}
          </CustomTabPanel>
        );
      })}
    </Box>
  );
};
